import React, { useState } from 'react';
import { Button, Stack, InputGroup, InputRightElement, IconButton, Select } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import ReusableDrawer from "../../../../components/Drawers/ReusableDrawer.js";
import headerImage from '../../../../assets/img/background.png'; 
import GradientButton from 'components/Buttons/GradientButton.js';
import ReusableInput from 'components/Inputs/ReusableInput.js';

const generateRandomPassword = (length = 12) => {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
  let password = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  return password;
};

const EditUserDrawer = ({ isOpen, onClose, onUpdateUser, user }) => {
  // State to hold form data initialized with user data
  const [formData, setFormData] = useState({
    
    password: '',
    region: user?.region || '',
  });

  // State to toggle password visibility
  const [show, setShow] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShow((prev) => !prev);
  };

  // Handle form field change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // Prepare data for submission
    const formDataToSubmit = { ...formData };

    // Pass updated user data back to the parent component
    onUpdateUser(formDataToSubmit);
    onClose(); // Close the drawer after updating the user
  };

  // Generate password and set it in the form data
  const handleGeneratePassword = () => {
    const newPassword = generateRandomPassword();
    setFormData((prev) => ({ ...prev, password: newPassword }));
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Update {user?.firstName}'s Details</h2>}
      bodyContent={
        <Stack spacing={4}>
         
           
         <InputGroup >
  <ReusableInput
    label="Password"
    name="password"
    type={show ? "text" : "password"}
    value={formData.password}
    onChange={handleInputChange}
    placeholder="*************"
  />
  <InputRightElement height="100%" mt={2} >
    {show ? (
      <ViewOffIcon onClick={togglePasswordVisibility} color="#8D93A1" />
    ) : (
      <ViewIcon onClick={togglePasswordVisibility} color="#8D93A1" />
    )}
  </InputRightElement>
</InputGroup>

          {/* Button to generate password */}
          <GradientButton onClick={handleGeneratePassword} size="sm">
            Generate Password
          </GradientButton>

        

          <ReusableInput
            label="Region"
            name="region"
            type="select" // Set type to 'select'
            value={formData.region}
            onChange={handleInputChange}
            options={[
              { value: 'North', label: 'North' },
              { value: 'South', label: 'South' },
              { value: 'East', label: 'East' },
              { value: 'West', label: 'West' },
              { value: 'Central', label: 'Central' },
            ]}
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize={"15px"} width={"100px"} height={"40px"}>Cancel</GradientButton>
          <GradientButton  fontSize={"15px"} width={"100px"} height={"40px"}>Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default EditUserDrawer;
